const CUSTOMER_STEP = 'CUSTOMER';
const SERVICE_STEP = 'SERVICE';
const PICK_UP_STEP = 'PICKUP';
const TIRE_PICK_UP_STEP = 'TIREPICKUP';
const DROP_OFF_STEP = 'DROPOFF';
const TIRE_DROP_OFF_STEP = 'TIREDROPOFF';
const PICK_UP_TIME_STEP = 'PICKUPTIME';
const DRIVER_STEP = 'DRIVER';
const TIRE_STEP = 'TIRE';
const CONCIERGE_DROP_OFF_STEP = 'CONCIERGEDROPOFF';
const API_DROP_OFF_STEP = 'APIDROPOFF';
const CASH_CALL_PAYMENT_PROCESSING_STEP = 'CASHCALLPAYMENTPROCESSING';
const SECONDARY_FEES = 'SECONDARYFEES';
const TERMINAL_DISPATCH_STEP = 'CreateDispatch';
const GQL_FETCH_CREATE_DISPATCH_RESOURCES_TIMEOUT = 12000;

const CONSTANTS = {
  TIMEOUTS: {
    GQL_FETCH_CREATE_DISPATCH_RESOURCES_TIMEOUT
  },
  WORKFLOW_TYPES: {
    CUSTOMER_STEP,
    SERVICE_STEP,
    PICK_UP_STEP,
    TIRE_PICK_UP_STEP,
    DROP_OFF_STEP,
    TIRE_DROP_OFF_STEP,
    PICK_UP_TIME_STEP,
    DRIVER_STEP,
    CONCIERGE_DROP_OFF_STEP,
    TIRE_STEP,
    API_DROP_OFF_STEP,
    CASH_CALL_PAYMENT_PROCESSING_STEP,
    SECONDARY_FEES,
    TERMINAL_DISPATCH_STEP
  },
  PROGRAMS: {
    NEW_BENEFITS_TYPES: [{
      value: 10,
      name: 'Tow Service'
    }, {
      value: 20,
      name: 'On-Site Service'
    }, {
      value: 30,
      name: 'Service Count'
    }],
    NEW_BENEFITS_CATEGORIES: {
      10: [{
        value: 10,
        name: 'X Miles Cost per mi/km'
      }, {
        value: 20,
        name: 'X Miles Cost Flat Rate'
      }, {
        value: 30,
        name: 'Flat Rate'
      }, {
        value: 40,
        name: '% of Dispatch'
      }, {
        value: 50,
        name: 'Max Rate'
      }],
      20: [{
        value: 10,
        name: 'Parts Only'
      }, {
        value: 15,
        name: 'Service Only'
      }, {
        value: 20,
        name: '% of Dispatch'
      }, {
        value: 30,
        name: 'Flat Rate'
      }, {
        value: 50,
        name: 'Max Rate'
      }],
      30: [{
        value: 10,
        name: 'X Services per Hour'
      }, {
        value: 20,
        name: 'X Services per Day'
      }, {
        value: 30,
        name: 'X Services per Week'
      }, {
        value: 40,
        name: 'X Services per Month'
      }, {
        value: 50,
        name: 'X Services per Year'
      }]
    }
  },
  ROADSIDE_DISPATCHING_STATUS: [
    {
      value: 1,
      name: 'Active',
    },
    {
      value: 0,
      name: 'Inactive'
    }
  ]
};

export default CONSTANTS;
